import TagManager from 'react-gtm-module';

/**
 * `type` identifies the hero variant, not the page template — the same hero
 * can be rendered on more than one page type, so the two must not be conflated
 * in reporting.
 */
export const PLP_HERO_TYPE = 'PLP hero';

export interface TrackPlpHeroCtaClickProps {
  data: {
    /** Path the click happened on, e.g. `/en/products/camping-and-hiking` */
    interactionLocation: string;
    /** Locale-prefixed href the CTA navigates to */
    linkUrl: string;
    linkText: string;
    /** 0-based position of the CTA within the hero (heroes allow up to 3) */
    index: number;
    coOpBrand: string | null;
  };
}

export const trackPlpHeroCtaClick = ({ data }: TrackPlpHeroCtaClickProps) => {
  const { interactionLocation, linkUrl, linkText, index, coOpBrand } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_hero_cta',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        link_text: linkText,
        // Sent as a string to match the other interaction trackers (see
        // trackCompareGridEvents) — GA4 reads it as a dimension, not a metric.
        index: index.toString(),
        coop_brand: coOpBrand || null,
        type: PLP_HERO_TYPE,
      },
    },
  });
};
